import { render } from "./UzhnetButton.vue?vue&type=template&id=3a956ac1&scoped=true"
import script from "./UzhnetButton.vue?vue&type=script&lang=js"
export * from "./UzhnetButton.vue?vue&type=script&lang=js"

import "./UzhnetButton.vue?vue&type=style&index=0&id=3a956ac1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a956ac1"]])

export default __exports__